import clsx from 'clsx'
import type { ReactElement } from 'react'
import { Shimmer } from '~/components/Global/Elements/Shimmer/Shimmer'
import {
  bubbleRow,
  bubbleRowContent,
  bubbleRowInbound,
  bubbleRowOutbound,
  bubbleWrapper
} from './MessageBubble.css'

export const MessageBubbleShimmer = ({
  inbound
}: {
  inbound: boolean
}): ReactElement => (
  <div
    className={clsx(bubbleRow, inbound ? bubbleRowInbound : bubbleRowOutbound)}
  >
    <div className={bubbleRowContent}>
      <div className={bubbleWrapper}>
        <Shimmer height={40} width={inbound ? 220 : 180} />
      </div>
    </div>
  </div>
)
